/**
 * Swiper chunk entry (assets/swiper-manager.js).
 *
 * Loaded ONLY by the sections that render carousels:
 *  - sections/image-slider-section.liquid
 *  - sections/carpet-posts.liquid (featured articles, mobile slider)
 *
 * Exposes window.swiperManager — the public contract consumed by
 * assets/image-slider.js and assets/featured-articles.js, which both
 * guard with `typeof swiperManager !== 'undefined'`, so pages without
 * this chunk degrade gracefully.
 *
 * Keeping Swiper out of the global bundle saves ~90KB of parse cost on
 * every non-carousel page.
 */
import SwiperManager from './swiperManager';

window.swiperManager = SwiperManager;
